import React from 'react'
import {
  Button,
  Table,
  Modal,
  Row,
  Col,
  Divider,
  Tag,
  Input,
  message
} from 'antd'
import numeral from 'numeral'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { Cell, Panel } from '../../../components'

export default class ComplementoPagoModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loadId: null,
      loading: false,
      search: '',
      form: this.defaultForm(),
      items: [],
    }
  }

  /**
   * defaultForm
   */
  defaultForm = () => ({
    iId: null,
    iIdArchivoPdf: null,
    dFecha: null,
  })

  /**
   * setFormValue
   *
   * @param {String} key
   * @param {Any} value
   */
  setFormValue = (key, value) => {
    if (typeof key === 'string') {
      this.setState({
        form: {
          ...this.state.form,
          [key]: value
        }
      })
    } else {
      this.setState({
        form: {
          ...this.state.form,
          ...key,
        }
      })
    }
  }

  /**
   * load
   */
  load = (id) => {
    this.setState({
      loading: true,
      visible: true,
    })

    const query = {
      __returnType: 'one',
      model: 'ComComplementoPago',
      attributes: Object.keys(this.defaultForm()).concat([
        'iIdUsuarioValida',
        'sFolio',
        'sCfdiUUID',
      ]),
      include: [
        {
          as: 'items',
          required: false,
          attributes: [
            'iId',
            'iIdTesFactura',
            'sFolio',
            'dMonto',
            'sUUIDItem',
          ],
          include: [{
            required: false,
            as: 'tesFactura',
            attributes: ['iIdPago'],
            include: [{
              required: false,
              as: 'pago',
              attributes: ['sNumeroTransferencia'],
            }]
          }]
        },
      ],
      where: { iId: id },
    }

    Api.query(query)
      .then(({ data }) => {
        this.setState({
          loading: false,
          loadId: id,
          items: data.items,
          form: {
            ...this.defaultForm(),
            ...data,
          }
        })
      })
      .catch(error => {
        Exception.load(error).show()
        this.setState({ loading: false })
      })
  }

  /**
   *
   */
  verificarRelaciones = async () => {
    if (!this.state.loadId) {
      return
    }

    this.setState(state => ({
      ...state,
      loading: true,
    }))

    try {
      await Api.post('/kernel/instances/methods/call', {
        model: 'ComComplementoPago',
        id: this.state.loadId,
        method: 'verificarRelaciones',
        params: [],
      })

      this.load(this.state.loadId)
    } catch (error) {
      Exception.load(error).show()
      this.setState(state => ({
        ...state,
        loading: false,
      }))
    }
  }

  /**
   *
   */
  onSave = () => {
    const data = {
      ...this.state.form,
      iIdProveedor: Api.getProviderId(),
      dFecha: this.state.form.dFecha,
    }

    if (!data.dFecha) { return message.warn('Falta especificar la fecha') }

    const id = data.iId || null
    const payload = { model: 'ComComplementoPago', id, values: data}

    Api.post('/kernel/mutator', payload)
      .then(response => {
        this.load(id ? id : response.data.record.iId)
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   *
   */
  onDelete = async () => {
    if (!this.state.loadId) {
      message.error('id de carga no definido')
    }

    this.setState(state => ({
      ...state,
      loading: true
    }))

    try {
      await Api.post('/kernel/mutator', {
        model: 'ComComplementoPago',
        id: this.state.loadId,
        values: { iActivo: false },
      })

      this.props.onDelete && this.props.onDelete()
      this.hide()
    } catch (err) {
      Exception.load(err).show()
      this.setState({ loading: false })
    }
  }

  /**
   *
   */
  hide = () => {
    this.setState({
      visible: false,
      loadId: undefined,
    })
  }

  /**
   *
   */
  showModal() {
    this.setState({
      loading: false,
      visible: true,
      search: '',
      form: this.defaultForm(),
    })
  }

  /**
   *
   * @param {File} file
   */
  uploadPDF = async (file) => {
    this.setState({ loading: true })

    const fileForm = Api.form({
      upload: file,
      tipo: 'WEB.PROV.COM.COMPLEMENTO_PAGO_PDF'
    })

    try {
      const { data: upload } = await Api.post('/upload/file', fileForm)

      this.setState(prev => ({
        ...prev,
        iIdArchivoPdf: upload.iId
      }))

      await Api.post('/kernel/mutator', {
        model: 'ComComplementoPago',
        id: this.state.loadId,
        values: { iIdArchivoPdf: upload.iId }
      })

      this.setState({ loading: false })

      this.load(this.state.loadId)
    } catch (error) {
      this.setState({ loading: false })
      Exception.load(error).show()
    }
  }

  /**
   *
   */
  attachPDF = () => {
    if (!this.state.loadId) {
      return
    }

    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.pdf'
    input.multiple = false
    input.onchange = e => {
      if (input.files.length > 0) {
        this.uploadPDF(input.files[0])
      } else {
        this.setState({ loading: false })
      }

      input.value = null
    }

    input.click()
  }

  /**
   *
   */
  removePDF = async () => {
    if (!this.state.loadId) {
      return
    }

    this.setState({ loading: true })

    try {
      await Api.post('/kernel/mutator', {
        model: 'ComComplementoPago',
        id: this.state.loadId,
        values: { iIdArchivoPdf: null }
      })

      this.load(this.state.loadId)
    } catch (error) {
      this.setState({ loading: false })
      Exception.load(error).show()
    }
  }

  /**
   *
   */
  downloadPDF = () => {
    if (!this.state.form.iIdArchivoPdf) {
      return
    }

    const a = document.createElement('a')
    a.href = Api.to(`/upload/file/${this.state.form.iIdArchivoPdf}`)
    a.target = '_blank'
    a.click()
  }

  /**
   * render
   */
  render() {
    const algunoNoEncontrado =
      this.state.items.findIndex(item => !item.iIdTesFactura) > -1

    const isLocked = Boolean(this.state.form.iIdUsuarioValida)

    const eliminable = !isLocked || (
      this.state.loadId
      && algunoNoEncontrado
      && !Boolean(this.state.items.find(item => item.iIdTesFactura))
    )

    const pdfAdjuntado = Boolean(this.state.form.iIdArchivoPdf)

    return (
      <Modal
        title='COMPLEMENTO DE PAGO'
        style={{ top: 20 }}
        width={'90%'}
        visible={this.state.visible}
        onOk={this.onSave}
        onCancel={this.hide}
        footer={
          <>
            {this.state.loading || !algunoNoEncontrado ? null :
              <Button
                key='verificarRelaciones'
                onClick={this.verificarRelaciones}
                children='Procesar no encontrados'
              />
            }

            {this.state.loading || !eliminable ? null :
              <Button
                key='eliminar'
                onClick={this.onDelete}
                children='Eliminar'
              />
            }

            <Button
              key='cerrar'
              onClick={this.hide}
              children='Cerrar'
            />
          </>
        }>

        <div style={{ display: 'flex' }}>
          {/* form */}
          <Panel style={{ minWidth: 300 }}>
            <Row style={styles.row}>
              <Col>
                <label>UUID</label>
                <Input
                  style={{ width: '100%' }}
                  value={this.state.form.sCfdiUUID}
                  readOnly={true}
                />
              </Col>
            </Row>

            <Row style={styles.row}>
              <Col>
                <label>FECHA</label>
                <Input
                  style={{ width: '100%' }}
                  value={this.state.form.dFecha}
                  readOnly={true}
                />
              </Col>
            </Row>

            <Row style={styles.row}>
              <Col>
                <label>PDF</label>

                <div>
                  {pdfAdjuntado ?
                    <div>
                      <Button
                        key='download-pdf'
                        onClick={this.downloadPDF}
                        children='Descargar PDF'
                      />

                      {isLocked ? null :
                        <>
                          <Divider type='vertical' />

                          <Button
                            key='remove-pdf'
                            onClick={this.removePDF}
                            children='Quitar PDF'
                          />
                        </>
                      }
                    </div> :

                    <Button
                      key='upload-pdf'
                      onClick={isLocked ? undefined : this.attachPDF}
                      children='Subir PDF'
                    />
                  }
                </div>
              </Col>
            </Row>
          </Panel>

          {/* divider */}
          {!this.state.loadId ? null : (
            <Divider type='vertical' />
          )}

          <Table
            rowKey='iId'
            size='small'
            rowClassName='row-pure'
            dataSource={this.state.items}
            columns={Cell.buildList([
              { width: '300px', title: 'Documento relacionado', dataIndex: 'sUUIDItem' },
              { width: '150px', title: 'Pago (Operación)', dataIndex: 'tesFactura.pago.sNumeroTransferencia' },
              { width: '120px', title: 'Monto', dataIndex: 'dMonto', render: val => numeral(val).format('$0,0.00') },
              { width: '120px', title: 'Status', dataIndex: 'iIdTesFactura', render: val =>
                <Tag
                  color={val ? 'blue' : 'orange'}
                  children={val ? 'ENCONTRADO' : 'NO ENCONTRADO'}
                />
              },
            ])}
            loading={this.state.loading}
            pagination={false}
          />
        </div>
      </Modal>
    )
  }
}

const styles = {
  row: {
    marginBottom: 10,
  }
}
